import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const AnalyticsView = React.lazy(() => import("./Analytics.view"));

const AnalyticsLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <AnalyticsView />
  </React.Suspense>
);

export default () => <AnalyticsLoadable />;
